import { createStore } from 'satcheljs';
import '../mutators/initializeCalendarProcessingOptionsMutator';
import '../mutators/updateCalendarProcessingOptionsMutator';
var initialStore = {
    calendarProcessingOptions: null,
};
export default createStore('calendarProcessingOptions', initialStore);
//# sourceMappingURL=store.js.map